import { createStore } from 'vuex';

export default createStore({
	state: {
		packageVersion: process.env.PACKAGE_VERSION || '0',
		showSnackbar: false,
		snackbarTitle: '',
		snackbarMsg: '',
		mutateMap: {}, // Map keys to mutate functions.
	},
	getters: {
		appVersion: (state) => state.packageVersion,
		showSnackbar: (state) => state.showSnackbar,
		snackbarTitle: (state) => state.snackbarTitle,
		snackbarMsg: (state) => state.snackbarMsg,
	},
	mutations: {
		setShowSnackbar(state, val) {
			state.showSnackbar = val;
		},
		showSnackbar(state, { title, message }) {
			state.showSnackbar = true;
			state.snackbarTitle = title;
			state.snackbarMsg = message;
		},
	},
	actions: {
		setShowSnackbar({ commit }, val) {
			commit('setShowSnackbar', val);
		},
		showSnackbar({ commit }, { title, message }) {
			commit('showSnackbar', { title, message });
		},
		addMutates({ state }, mutates) {
			for (const { key, mutate } of mutates) {
				state.mutateMap[key] = mutate;
			}
		},
		updateMutatesKeys({ state }, mutates) {
			for (const { prevKey, key } of mutates) {
				state.mutateMap[key] = state.mutateMap[prevKey];
				delete state.mutateMap[prevKey];
			}
		},
		removeMutates({ state }, keys) {
			for (const key of keys) {
				delete state.mutateMap[key];
			}
		},
		invalidateKeys({ state }, keys) {
			if (!(keys instanceof Array)) keys = [keys];
			for (const key of keys) {
				if (!Object.prototype.hasOwnProperty.call(state.mutateMap, key)) {
					console.warn(`invalidateKeys: received an unknown key ${key}`);
					continue;
				}
				// TODO: Error handling here. Can this throw?
				state.mutateMap[key]();
			}
		},
	},
	modules: {},
});
